/**
 * LED port "off-state" gate.
 *
 * Centralises the decision "should the renderer touch the LED COM port
 * right now?" so every call site can answer it the same way.
 *
 * Why a separate helper:
 *   - `settings.enableLedDisplay` arrives in multiple shapes (boolean, 0/1,
 *     '1'/'true' from localStorage cache, undefined when the toggle has
 *     never been set). Centralising the truthy test keeps the behaviour
 *     consistent across call sites.
 *   - The previous behaviour only checked this flag inside two methods of
 *     `ledService.js`. Every other path (cart-change broadcast, payment
 *     complete, invoice Next-Sale, etc.) opened the COM port even when
 *     LED was disabled, which prevented other programs from using the
 *     same serial port.
 *   - Fail-safe default is DISABLED: if the settings object is missing,
 *     empty, or the enable flag is not recognisably truthy, we treat the
 *     LED as off and the COM port stays free.
 *
 * Consumed by:
 *   - src/services/ledService.js
 *   - src/store/modules/Sale/sales-module.js
 *   - src/views/point-of-sale/payment/ViewInvoicesView.vue
 *
 * Test: tests/unit/ledGate.spec.js
 */

const isTruthyEnable = (value) => {
    if (value === true || value === 1) return true;
    if (typeof value === 'string') {
        const normalised = value.trim().toLowerCase();
        return normalised === '1' || normalised === 'true';
    }
    return false;
};

export function isLedDisabled(settings) {
    if (!settings || typeof settings !== 'object') return true;
    return !isTruthyEnable(settings.enableLedDisplay);
}

export default { isLedDisabled };
